<template>
    <div>

        <div class="header" :style="{backgroundImage:'url('+store.mb_title_img+')'}">
          <div class="content-wrapper">
            <div class="avatar" @click="goStoreabout">
              <img :src="store.store_avatar">
            </div>
            <div class="content">
              <div class="store_name">{{store.store_name}}<span class="ml-5" v-if="(store.is_platform_store && config.business_licence) || store.business_licence_number_electronic" @click="imageVisible=true"><i class="iconfont">&#xe621;</i></span></div>
              <div class="store_address" v-if="store.store_address" @click="$router.push({name:'HomeStoremap',query:{id:store.store_id}})">
                <span class="iconfont">&#xe6d3;</span>
                <span v-if="store.store_address">{{store.store_address}}</span>
              </div>
            </div>
            <div class="follow_panel">
              <div class="follow_button" @click="toggleFavorite" >
                <i class="iconfont" :class="{'active':store.is_favorate}" v-html="favoriteIco"></i>
                {{favoriteName}}
              </div>
              <div class="follow_number">
                {{store.store_collect}} جمع كمية
              </div>
            </div>
            <i class="header-more iconfont" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></i>
          </div>
          <div class="background">
            <img v-if="store.store_logo" v-lazy="store.store_logo" width="100%" height="100%">
            <img v-else v-lazy="store.store_logo" width="100%" height="100%">
          </div>
        </div>
        <header-more v-show="popupVisible" :showDot="showDot"></header-more>

        <div class="common-search">
            <input type="text" placeholder="ابحث عن منتجات المتجر" readonly="true" autocomplete="off" v-model="params.keyword" @click="$router.push({name:'HomeStoreGoodsclass',query:{id:store_id}})">
        </div>
        <goodslist-body></goodslist-body>
        <common-store-footer :store_id="store_id"></common-store-footer>
    </div>
</template>

<script>
import CommonStoreFooter from '../common/CommonStoreFooter'
import {mapState, mapMutations, mapActions} from 'vuex'
import GoodslistBody from './GoodslistBody'
import {getStoreInfo} from "@/api/homestoredetail";
import {Toast} from "mint-ui";
import {addFavoriteStore, delFavoriteStore} from "@/api/memberFavorite";
import HeaderMore from '../../HeaderMore';

export default {
  name: 'StoreGoodslist',
  components: {
    HeaderMore,
    CommonStoreFooter,
    GoodslistBody
  },
  data () {
    return {
      store_id: this.$route.query.id ? this.$route.query.id : '',
      store: {
        store_id: this.$route.query.id ? this.$route.query.id : ''
      },
      popupVisible: false, // 弹出更多
      showDot: false,
      params: {
        keyword: this.$route.query.keyword ? this.$route.query.keyword : ''
      }

    }
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      token: state => state.member.token,
      isOnline: state => state.member.isOnline
    }),
    favoriteIco () {
      return this.store.is_favorate ? '&#xe64d;' : '&#xe64e;'
    },
    favoriteName () {
      return this.store.is_favorate ? 'جمعت' : 'المفضلة'
    }
  },
  created () {
    getStoreInfo(
        this.store.store_id, this.token
    ).then((res) => {
      this.store = res.result.store_info
    }).catch(function (error) {

    })
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    goStoreabout: function () {
      this.$router.push({ name: 'HomeStoreabout', query: { id: this.$route.query.id } })
    },
    // 弹出更多
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    toggleFavorite () {
      if (!this.store.is_favorate) {
        addFavoriteStore(this.store.store_id).then(
            response => {
              Toast(response.message)
              this.store.is_favorate = !this.store.is_favorate
            },
            error => {
              Toast(error.message)
            }
        )
      } else {
        delFavoriteStore(this.store.store_id).then(
            response => {
              Toast(response.message)
              this.store.is_favorate = !this.store.is_favorate
            },
            error => {
              Toast(error.message)
            }
        )
      }
    }
  }
}
</script>

<style scoped>
    .common-search{
        padding:0.4rem 0.6rem;
    }
    .common-search input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        border-radius:0.2rem;
        background: #EDEDED url(../../../assets/image/home/icon_search.png) no-repeat 0.6rem center;
        background-size:0.55rem;
        font-size:0.7rem;
        color: #999;
        padding-left:1.65rem;
        border: 0;
    }
    .dot{position:absolute;width:.5rem;height:.5rem;background:red;border-radius:50%;top:.2rem;right:0;}
    .header {background: rgba(7,17,27,.5);color: #fff;overflow: hidden;position: relative;background-position: center;background-size: auto 100%;}
    .header .content-wrapper {-ms-flex-align: center;-webkit-box-align: center;align-items: center;display: -webkit-box;display: -ms-flexbox;display: flex;padding:0.8rem 0.4rem;position: relative;}
    .header .content-wrapper .avatar {-ms-flex: 0 0 3rem;-webkit-box-flex: 0;flex: 0 0 3rem;margin-right:0.4rem;width:3rem;}
    .header .content-wrapper .avatar img {border-radius:0.1rem;width:3rem;height:3rem;}
    .header .content-wrapper .content {position:relative;width:5.6rem;}
    .header .content-wrapper .content .store_name {font-size:.8rem;font-weight: 700;margin-bottom:.4rem;}
    .header .content-wrapper .content .store_address span{font-size: .7rem}
    .follow_panel{position:absolute;top:1rem;right:2rem;}
    .follow_panel .follow_button{display:block;background:#e93b3d;border-radius:2.5rem;padding:0 0.4rem;line-height:1.2rem;font-size:0.6rem;color:#fff;}
    .follow_panel .follow_button i{line-height:1.2rem;}
    .follow_panel .follow_number{text-align:center;line-height:0.7rem;font-size:0.5rem;color:#fff;margin-top:0.1rem;}
    .header-more{width:2rem;height:2rem;line-height:2rem;position:absolute;top:0.5rem;right:0;color:#fff;text-align:center;font-size:1rem;}
    .header .background {background:#2c3b53;-webkit-filter: blur(0.5rem);filter: blur(0.5rem);height: 100%;left: 0;position: absolute;top: 0;width: 100%;z-index: -1;}
</style>
